import { thirdwebClient } from 'src/common/api-clients/thirdweb'
import { Chain, getContract } from 'thirdweb'
import { Abi } from 'thirdweb/utils'

export const _getThirdwebContract = (
  contractAddress: string,
  chain: Chain,
  abi?: Abi
) => {
  if (!contractAddress) {
    return {
      address: contractAddress,
      client: thirdwebClient,
      chain,
      abi,
    } as ReturnType<typeof getContract>
  }
  const contract = getContract({
    address: contractAddress,
    chain: chain,
    client: thirdwebClient,
    abi: abi,
  })

  return contract
}
